import { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useImmer } from 'use-immer'
import { Button, FormControl, FormLabel, Grid, Input, Select, VStack } from '@chakra-ui/react'

export const DISPLAY_PRICING_PITCHES = ['6mm', '10mm', '15mm', '20mm']

export const DisplayPricingFormType = {
  Add: 'add',
  Edit: 'edit'
}

export const DisplayPricingForm = ({ type, onSubmit, isSubmitting, initialForm = null }) => {
  const [form, setForm] = useImmer({
    keyNo: 0,
    pitch: '',
    boardMatrix: 0,
    calculatedBoardMatrix: '',
    noOfLines: 0,
    noOfCharacters: 0,
    modsH: 0,
    modsL: 0,
    dimsH: '',
    dimsW: '',
    sfPrice: 0,
    dfPrice: 0,
    typicalAmps120: 0,
    maxAmps120: 0,
    typicalAmps240: 0,
    maxAmps240: 0
  })

  const buttonText = useMemo(() => {
    switch (type) {
      case DisplayPricingFormType.Add:
        return 'Add Pricing'
      case DisplayPricingFormType.Edit:
        return 'Save Pricing'
    }
  }, [type])

  useEffect(() => {
    setForm(draft => {
      Object.keys(initialForm || {}).forEach(k => { draft[k] = initialForm[k] ?? '' })
    })
  }, [initialForm])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid templateColumns="repeat(2, 1fr)">
        <VStack gap={2} maxW="500px">
          <FormControl isRequired>
            <FormLabel>Key No</FormLabel>
            <Input type="number" name="keyNo" value={form.keyNo} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Pitch</FormLabel>
            <Select name="pitch" value={form.pitch} onChange={handleChange} placeholder="Select ...">
              {DISPLAY_PRICING_PITCHES.map(v => <option key={v} value={v}>{v}</option>)}
            </Select>
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Board Matrix</FormLabel>
            <Input type="number" name="boardMatrix" value={form.boardMatrix} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Calculated Board Matrix ( e.g. 30 * 150 )</FormLabel>
            <Input name="calculatedBoardMatrix" value={form.calculatedBoardMatrix} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>No of Lines</FormLabel>
            <Input type="number" name="noOfLines" value={form.noOfLines} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>No of Characters</FormLabel>
            <Input type="number" name="noOfCharacters" value={form.noOfCharacters} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Module Height</FormLabel>
            <Input type="number" name="modsH" value={form.modsH} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Module Length</FormLabel>
            <Input type="number" name="modsL" value={form.modsL} onChange={handleChange} />
          </FormControl>
        </VStack>
        <VStack gap={2} maxW="500px">
          <FormControl isRequired>
            <FormLabel>{'DIMS H ( e.g. 1\' 0" )'}</FormLabel>
            <Input name="dimsH" value={form.dimsH} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>{'DIMS W ( e.g. 1\' 0" )'}</FormLabel>
            <Input name="dimsW" value={form.dimsW} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>SF Price</FormLabel>
            <Input type="number" name="sfPrice" value={form.sfPrice} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>DF Price</FormLabel>
            <Input type="number" name="dfPrice" value={form.dfPrice} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Typical Amps 120v</FormLabel>
            <Input type="number" name="typicalAmps120" value={form.typicalAmps120} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Max Amps 120v</FormLabel>
            <Input type="number" name="maxAmps120" value={form.maxAmps120} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Typical Amps 240v</FormLabel>
            <Input type="number" name="typicalAmps240" value={form.typicalAmps240} onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Max Amps 240v</FormLabel>
            <Input type="number" name="maxAmps240" value={form.maxAmps240} onChange={handleChange} />
          </FormControl>
        </VStack>
      </Grid>
      <Button type="submit" mt={8} colorScheme="blue" isLoading={isSubmitting}>{buttonText}</Button>
    </form>
  )
}

DisplayPricingForm.propTypes = {
  type: PropTypes.oneOf(Object.values(DisplayPricingFormType)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  initialForm: PropTypes.object
}
